import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"
import Trix from "trix"

export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    this.editor = this.fieldTarget.editor
    this.initializeTribute()
  }

  initializeTribute() {
    const organizationType = this.detectOrganizationType()
    const fields = this.getFieldsByType(organizationType)

    this.tribute = new Tribute({
      collection: [
         {
           trigger: "{{",
           allowSpaces: true,
           lookup: "key",
           menuShowMinLength: 0,
           menuItemLength: 10,
           menuContainer: document.querySelector('.modal-body .os-content'),
           values: fields
         }
       ]
    });

    this.tribute.attach(this.fieldTarget)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
  }

  detectOrganizationType() {
    const path = window.location.pathname
    return path.includes('/ats/company/') ? 'company' : 'hunter'
  }

  getFieldsByType(organizationType) {
    const translations = {
      candidate_name: this.fieldTarget.dataset.candidateName,
      job_title: this.fieldTarget.dataset.jobTitle,
      company_name: this.fieldTarget.dataset.companyName,
      job_headers: this.fieldTarget.dataset.jobHeaders,
      candidate_step: this.fieldTarget.dataset.candidateStep,
      company_employee_name: this.fieldTarget.dataset.companyEmployeeName,
      hunter_employee_name: this.fieldTarget.dataset.hunterEmployeeName,
      hiring_manager_name: this.fieldTarget.dataset.hiringManagerName,
      job_owner_name: this.fieldTarget.dataset.jobOwnerName
    }

    const commonFields = [
      { key: translations.candidate_name || 'Candidate Name', value: 'Candidate Name'},
      { key: translations.job_title || 'Job Title', value: 'Job Title'},
      { key: translations.company_name || 'Company Name', value: 'Company Name'},
      { key: translations.job_headers || 'Job Headers', value: 'Job Headers'},
      { key: translations.candidate_step || 'Candidate Step', value: 'Candidate Step'}
    ]

    const specificFields = organizationType === 'company'
      ? [
          { key: translations.company_employee_name || 'Company Employee Name', value: 'Company Employee Name'},
          { key: translations.hiring_manager_name || 'Hiring Manager Name', value: 'Hiring Manager Name'},
          { key: translations.job_owner_name || 'Job Owner Name', value: 'Job Owner Name'}
        ]
      : [
          { key: translations.hunter_employee_name || 'Hunter Employee Name', value: 'Hunter Employee Name'},
          { key: translations.hiring_manager_name || 'Hiring Manager Name', value: 'Hiring Manager Name'},
          { key: translations.job_owner_name || 'Job Owner Name', value: 'Job Owner Name'}
        ]

    return [...commonFields, ...specificFields]
  }

  replaced(event) {
    let mention = event.detail.item.original
    this.editor.insertHTML(`<del>${mention.key}</del>&nbsp;`)
    this.editor.insertHTML(' ')
  }

  _pasteHtml(html, startPos, endPos) {
    let range = this.editor.getSelectedRange()
    let position = range[0]
    let length = endPos - startPos

    this.editor.setSelectedRange([position - length, position])
    this.editor.deleteInDirection("backward")
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget)
  }
}
